import React, { useEffect, useState } from "react";
import { Card, Text, Title, Box, Stack, Table, Group, Image, Container, Accordion } from "@mantine/core";
import { IconCaretDownFilled, IconCaretRightFilled, IconBrandFacebook } from '@tabler/icons-react';
import { Chart } from "react-google-charts";
import { ReportChartStyle, VisiLoader } from "../../components/GeneralComponent/GeneralComponent";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

export function DemoReport() {

  const sheetUrl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vRX33VbfIFi0hQh8pltdJGgsmrzCMd_k70dsoXoWGSmU6IF7QR-1YxLb53vCiXiwnswok65ddztBNgv/pub?output=csv";

  const [showLoader, setShowLoader] = useState(false);
  const [allData, setAlldata] = useState([]);
  const [stackedBarChartData, setStackedBarChartData] = useState([]);
  const [sourcePieChartData, setSourcePieChartData] = useState([]);
  const [pieChartSourceColorsArray, setPieChartSourceColorsArray] = useState([]);
  const piechart_color_array = ['#7DF9FF', '#D8F5A1', '#48D1CC', '#FFB3BA', '#FFDFBA', '#FFFFBA', '#BAFFC9', '#BAE1FF', '#E2BAFF', '#AA4643'];
  const [campaignColumns, setCampaignColumns] = useState([]);
  const [campaignValueData, setCampaignValueData] = useState([]);
  const [expandCampaignTable, setExpandCampaignTable] = useState(false);
  const [campaignGoalTableData, setCampaignGoalTableData] = useState([]);
  const [campaignGoalBlocksData, setCampaignGoalBlocksData] = useState([]);
  const [expandGoalTable, setExpandGoalTable] = useState(false);
  const [expandTrafficSourceTable, setExpandTrafficSourceTable] = useState(false);
  const [trafficSourceTableColumns, setTrafficSourceTableColumns] = useState([]);
  const [trafficSourceTableData, setTrafficSourceTableData] = useState([]);
  const [campaignUniques, setCampaignUniques] = useState('');

  const goalMetricsColumns = [
    { key: 'visi_goal_name', value: 'GoalName' },
    { key: 'goal_ucr', value: 'UCR' },
    { key: 'goal_gcr', value: 'CR' },
    { key: 'goal_cpg', value: 'CPA' },
    { key: 'goal_epg', value: 'EPG' },
    { key: 'goal_arpu', value: 'Avg. Revenue per Unique' },
  ];

  useEffect(() => {
    const conversions = Number(campaignGoalBlocksData[1]?.visiopt_conversions) || 0;
    const uniques = Number(campaignUniques) || 0;
    const unique_percentage = uniques > 0 ? (conversions / uniques) * 100 : 0;
    if (campaignGoalBlocksData[1]) {
      let uniquePercentage = 0;
      if (!isFinite(uniquePercentage)) {
        uniquePercentage = 0;
      }
      uniquePercentage = parseFloat(unique_percentage.toFixed(2)) || 0;
      campaignGoalBlocksData[1].unique_percentage = uniquePercentage + "% Visits from LP Page";
    }
  }, [campaignUniques]);

  useEffect(() => {
    setShowLoader(true);
    fetch(sheetUrl)
      .then((res) => res.text())
      .then((data) => {
        const rows = data
          .split("\n")
          .map((row) =>
            row
              .split(",")
              .map((cell) => cell.trim())
              .filter((cell) => cell !== "")
          )
          .filter((row) => row.length > 0);
        setAlldata(rows);
        setShowLoader(false);
      })
      .catch((err) => {
        console.error(err);
        setShowLoader(false);
      });
  }, []);

  useEffect(() => {
    if (allData.length > 0 && allData[0].includes("Stacked Bar")) {
      const dateArr = allData[0].filter((d) => !d.includes('Stacked Bar'));
      const costArr = allData[1].filter((d) => !d.includes('cost'));
      const revenueArr = allData[2].filter((d) => !d.includes('revenue'));
      if(dateArr.length > 0){
        setStackedBarChartData((prev) => [
          ...prev,
          ['Date', 'Total Cost', 'Total Revenue'],
        ]);
        dateArr.forEach((value, index) => {
          setStackedBarChartData((prev) => [
            ...prev,
            [value, parseInt(costArr[index], 10), parseInt(revenueArr[index], 10)],
          ]);
        })
      }
    }
    if (allData.length > 0 && allData[3].includes("Source Pie")) {
      const sourcePieArr = allData[3].filter((d) => !d.includes('Source Pie'));
      const sourcePieValArr = allData[4].filter((d) => !d.includes('value'));
      if(sourcePieArr.length > 0){
        const sourcePieColors: string[] = [];
        setSourcePieChartData((prev) => [
          ...prev,
          ['Label', 'Value'],
        ]);
        sourcePieArr.forEach((value, index) => {
          setSourcePieChartData((prev) => [
            ...prev,
            [value, parseInt(sourcePieValArr[index], 10)],
          ]);
          sourcePieColors.push(piechart_color_array[index]);
        });
        setPieChartSourceColorsArray(sourcePieColors);
      }
    }
    if (allData.length > 0 && allData[5].includes("Campaign columns") && allData[6].includes("Campaign values")) {
      const campaignColumnsArr = allData[5].filter((d) => !d.includes('Campaign columns') && !d.includes('Lp Page Image'));
      const campaignValuesArr = allData[6].filter((d, i, arr) => !d.includes('Campaign values') && i !== arr.length);
      setCampaignColumns(campaignColumnsArr);
      setCampaignValueData(campaignValuesArr);
      setCampaignUniques(campaignValuesArr[2]);
      const lpPageImage = campaignValuesArr[campaignValuesArr.length - 1];
      const lpBlock = {
        custom_title: "LP Page",
        thumb: lpPageImage,
        visiopt_campaign: campaignValuesArr[0],
        uniques: campaignValuesArr[1],
        visits: campaignValuesArr[2],
      };
      setCampaignGoalBlocksData((prev) => [
        ...prev, lpBlock
      ]);
    }
    if (allData.length > 0 && allData[7].includes("Goal Name") && allData[8].includes("Goal Conversion") && allData[9].includes("UCR") && allData[10].includes("CR") && allData[11].includes("CPA") && allData[12].includes("EPG") && allData[13].includes("Avg. Revenue per Unique")) {
      const goalNamesArr = allData[7].filter((d) => !d.includes('Goal Name'));
      const goalConvArr = allData[8].filter((d) => !d.includes('Goal Conversion'));
      const goalUCRArr = allData[9].filter((d) => !d.includes('UCR'));
      const goalCrArr = allData[10].filter((d) => !d.includes('CR'));
      const goalCpaArr = allData[11].filter((d) => !d.includes('CPA'));
      const goalEpgArr = allData[12].filter((d) => !d.includes('EPG'));
      const goalAvgArr = allData[13].filter((d) => !d.includes('Avg. Revenue per Unique'));
      const goalImageArr = allData[14].filter((d) => !d.includes('Goal Page Screenshot'));
      goalNamesArr.forEach((goalName, index) => {
        const goalObj = {
          [`Goal - ${goalName}`]: goalConvArr[index],
          goal_ucr: goalUCRArr[index],
          goal_gcr: goalCrArr[index],
          goal_cpg: goalCpaArr[index],
          goal_epg: goalEpgArr[index],
          goal_arpu: goalAvgArr[index],
        };
        setCampaignGoalTableData((prev) => [
          ...prev, goalObj
        ]);
        let uniquePercentage = 0;
        let uniquesPercentageText = '';
        if(index === 0){
          if(campaignValueData[2] !== 0){
            uniquePercentage = (goalConvArr[index] / campaignValueData[2]) * 100;
          }
          uniquesPercentageText = '% Visits from LP Page';
        }else{
          if(goalConvArr[index - 1].visiopt_conversions !== 0){
            uniquePercentage = (goalConvArr[index] / goalConvArr[index - 1]) * 100;
          }
          uniquesPercentageText = '% Visits from ' + goalNamesArr[index - 1];
        }
        if (!isFinite(uniquePercentage)) {
          uniquePercentage = 0;
        }
        uniquePercentage = parseFloat(uniquePercentage.toFixed(2)) || 0;
        const goalBlockObj = {
          [`Goal - ${goalName}`]: goalConvArr[index],
          visiopt_conversions: goalConvArr[index],
          gcr: goalCrArr[index],
          ucr: goalUCRArr[index],
          custom_title: goalName,
          thumb: goalImageArr[index] ?? "https://static.visiopt.com/page-thumb/no_screenshot_new.png",
          unique_percentage: uniquePercentage + uniquesPercentageText,
        };
        setCampaignGoalBlocksData((prev) => [
          ...prev, goalBlockObj
        ]);
      });
    }
    if (allData.length > 0 && allData[15].includes("Traffic Source")){
      const trafficSourceColumns = allData[15];
      setTrafficSourceTableColumns(trafficSourceColumns);
      const trafficDataRows = allData.slice(16).map((row) => {
        return row.map((cell, colIndex) => {
          if (row[0] === "Total") {
            const colName = trafficSourceColumns[colIndex];
            if (colName === "Campaign Name" || colName === "Adset Name" || colName === "Ad Name") {
              return "-";
            }
          }
          return cell ?? "0";
        });
      });
      setTrafficSourceTableData(trafficDataRows);
    }
  }, [allData]);

  const pieChartOptions = {
    title: "Sources",
    pieSliceText: 'none',
    colors: pieChartSourceColorsArray,
    titleTextStyle: {
      color: "#4D4D4D",
      fontSize: 18,
    },
    backgroundColor: "#ffffff",
    legend: {
      textStyle: {
        color: "black"
      }
    }
  };

  const handleCampaignClick = () => {
    setExpandCampaignTable(!expandCampaignTable);
  };

  const getFontSize = (value) => {
    if (!value) return "1rem";
    if (value <= 3) return "1.4rem";
    if (value <= 4) return "1.2rem";
    return "1rem";
  };

  const goalCards = (goalName:any, uniques:any, visits:any, conversionValue:any, ucbValue:any, crValue:any, imagePath:any, visitText:any) => {
    const allValues = [uniques, visits, conversionValue, ucbValue, crValue].filter((v) => v !== undefined && v !== null);
    const maxLength = Math.max(...allValues.map((v) => v.toString().length));
    const fontSize = getFontSize(maxLength);
    return(
      <td>
        <Card radius="md" withBorder style={{ height: '250px' , width: '260px'}}>
          <div style={{ height: '40%', width: '100%' }}>
            <Text weight={750} size = {15} color = 'grey' style={{ position: 'absolute', top: 7, left: 10, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', width: '250px', cursor: 'pointer' }} title={goalName}>{goalName}</Text>
              {(uniques !== undefined && visits !== undefined)&& (
                <Group mt="md" spacing="xl">
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: 10, fontSize}}>{uniques}</Text>
                    <Text size={11} c="dimmed" style={{display: 'flex' , position: 'absolute', top: 56, left: 10}}>Uniques</Text>
                  </div>
                  <div>
                    <Text weight={700} style={{position: 'absolute' , top: 30, left: 100, fontSize}}>{visits}</Text>
                    <Text size={11} c="dimmed" style={{display: 'flex' , position: 'absolute', top: 56, left: 100}}>Visits</Text>
                  </div>
                </Group>
              )}

              {(conversionValue !== undefined && ucbValue !== undefined && crValue !== undefined) && (
               <Group mt="md" spacing="xl">
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: 10, fontSize}}>{conversionValue}</Text>
                    <Text size={11} c="dimmed" style={{display: 'flex', position: 'absolute', top: 56, left: 10}}>Conversion</Text>
                  </div>
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: '81px', fontSize}}>{ucbValue}<span style={{position: 'relative' , top: '0.4em', fontSize :'0.7em'}}>%</span></Text>
                    <Text size={11} c="dimmed" style={{display: 'flex', position: 'absolute', top: 56, left: '81px'}}>UCR</Text>
                  </div>
                  <div>
                    <Text weight={700} style={{display: 'flex', position: 'absolute' , top: 30, left: '152px', fontSize}}>{crValue}<span style={{position: 'relative' , top: '0.4em', fontSize :'0.7em'}}>%</span></Text>
                    <Text size={11} c="dimmed" style={{display: 'flex', position: 'absolute', top: 56, left: '152px'}}>CR</Text>
                  </div>
                  <Text size = {12} weight={600} style={{display: 'flex', position: 'absolute' , top: 83,left: 10,wordWrap: 'break-word', whiteSpace: 'normal'}} color={'gray'}>{visitText}</Text>
                </Group>
                )}
            </div>
            <Card.Section style={{ borderTop: '3px solid #174c80' }}>
              <Image src={imagePath} />
            </Card.Section>
      </Card>
    </td>
    );
  }

  return (
    <>
      <VisiLoader VisiLoaderVisible={showLoader}/>
      <Container size="xxl">
        <Card shadow="sm" padding="sm" radius="md" withBorder>
          <Box pos="relative">
            <div style={{ display: 'flex',marginBottom: 50}}>
              <Box style={{ width: '70%', marginTop: '1rem', textAlign: 'center' }}>
                <Box style={{ textAlign: "left" }}>
                  <Box ml={60}>
                    <Stack spacing={4} justify="flex-start">
                      <Text size="1rem" fw={500} c={"#4D4D4D"}>
                        Total Revenue vs Ad Spend (Stacked Bar)
                      </Text>
                    </Stack>
                  </Box>
                  {stackedBarChartData.length > 1 ? (
                    <Chart
                      chartType="ColumnChart"
                      data={stackedBarChartData}
                      options={{
                        isStacked: true,
                        legend: { position: 'bottom', alignment: 'center', layout: 'vertical',textStyle: { color: "black" }},
                        bar: { groupWidth: "30%" },
                        colors: ['#FF0800', '#009000'],
                        backgroundColor: "#ffffff",
                        chartArea: { height: 'auto', width: '90%', top: '20', left: '60' },
                        hAxis: {
                          title: "Date",
                          slantedText: true,
                          slantedTextAngle: 45,
                          textStyle: { color: "black" },
                          titleTextStyle: { color: "black" }
                        },
                        vAxis: {
                          title: "Amount($)",
                          textStyle: { color: "black" },
                          titleTextStyle: { color: "black" }
                        },
                      }}
                      style={{ width: '100%', height: '400px' }}
                    />
                  ) : (
                    <ReportChartStyle />
                  )}
                </Box>
              </Box>
              <Box style={{ width: '30%', marginTop: '1rem' }}>
                <Chart
                  chartType="PieChart"
                  data={sourcePieChartData}
                  width={"100%"}
                  height={"300px"}
                  options={pieChartOptions}
                />
              </Box>
            </div>
          </Box>
          <Table striped highlightOnHover withBorder my={15} fontSize="xs" style={{tableLayout: 'fixed'}} withColumnBorders>   
            <thead>
              <tr>
                {campaignColumns.length > 0 &&
                  campaignColumns
                  .map((dataColumns, index) => (
                    <th key={index}>{dataColumns}</th>
                  ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {campaignColumns
                  .map((dataColumns, colIndex) => (
                  <td
                    key={colIndex}
                    style={{ width: 200, cursor: "pointer" }}
                    onClick={() => handleCampaignClick()}
                  >
                    {campaignValueData[colIndex] !== undefined
                      ? campaignValueData[colIndex]
                      : null}
                  </td>
                ))}
              </tr>
              {expandCampaignTable && (
                <>
                  <tr>
                    <td colSpan={campaignColumns.length}>
                      <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}> 
                        <table>
                          <tbody>
                            <tr>
                              {campaignGoalBlocksData && campaignGoalBlocksData.map((goal, index) => {
                                return (
                                  <>
                                    {index !== 0 && <div className="page-arrow" style={{ marginTop: "75%" }} />}
                                    {goalCards(goal.custom_title, goal.uniques,goal.visits,goal.visiopt_conversions, goal.ucr, goal.gcr, goal.thumb, goal.unique_percentage)}
                                  </>
                                );
                              })}
                            </tr>
                          </tbody>
                        </table>
                      </SimpleBar>
                    </td>
                  </tr>
                  <div style={{ minWidth: '2000px' }}>
                    <Card radius="sm" withBorder style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => setExpandGoalTable(!expandGoalTable)}>
                          <Title order={6} weight={500} color={'#262323'}>Goals</Title>
                          {expandGoalTable && <IconCaretDownFilled />}
                          {!expandGoalTable && <IconCaretRightFilled />}
                        </div>
                        {expandGoalTable && (
                          <div style={{ marginLeft: '-10px', marginTop: '20px' }}>
                            {campaignGoalTableData?.map((goalTable, goalIndex) => (
                              <Table striped highlightOnHover withBorder my={5} fontSize="xs" key={goalIndex} style={{ width: '100%', tableLayout: 'auto' }} withColumnBorders>
                                <thead>
                                  <tr>
                                    {goalMetricsColumns.length > 0 &&
                                      goalMetricsColumns.find((c) => c.key === 'visi_goal_name') && (
                                        <th style={{ width: '10%', textAlign: 'left' }}>
                                          {Object.keys(goalTable)[0]}
                                        </th>
                                      )}
                                    {goalMetricsColumns.slice(1).map((col, i) => (
                                      <th key={i} style={{ width: '10%', textAlign: 'left' }}>
                                        {col.value}
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    {goalMetricsColumns.length > 0 &&
                                      goalMetricsColumns.find((c) => c.key === 'visi_goal_name') && (
                                        <td>{goalTable[Object.keys(goalTable)[0]]}</td>
                                      )}
                                    {goalMetricsColumns.slice(1).map((col, i) => (
                                      <td key={i} style={{ textAlign: 'left' }}>
                                        {goalTable[col.key] ?? null}
                                      </td>
                                    ))}
                                  </tr>
                                </tbody>
                              </Table>
                            ))}
                          </div>
                        )}
                    </Card>
                  </div>
                </>
              )}
            </tbody>
          </Table>
          <Card radius="sm" withBorder style={{ position: 'relative', marginTop: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', position: 'absolute', top: 0, left: 5, cursor: 'pointer', width: '100%' }} onClick={() => setExpandTrafficSourceTable(!expandTrafficSourceTable)}>
              <Title order={6} weight={500} color={"#262323"}>Traffic Source</Title>
              {expandTrafficSourceTable && <IconCaretDownFilled />}
              {!expandTrafficSourceTable && <IconCaretRightFilled />}
            </div>
            {expandTrafficSourceTable && (
              <>
                <div style={{ marginLeft: '-10px', marginTop: '20px' }}>
                  <Accordion variant="contained" value="facebook">
                    <Accordion.Item value="facebook">
                      <Accordion.Control>
                        <Group spacing="xs" align="center">
                          <IconBrandFacebook size={20} color="#1877F2" />
                          <Text fw={500} size="md" c={"#1877F2"}>
                            Facebook
                          </Text>
                        </Group>
                      </Accordion.Control>
                      <Accordion.Panel>
                        <Text weight={500} size={20} style={{ marginTop: '20px', marginLeft: '5px' }}>{campaignValueData[0]}</Text>
                        <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '12px'}}> 
                          <table>
                            <tbody>
                              <tr>
                                {campaignGoalBlocksData && campaignGoalBlocksData.map((goal, index) => {
                                  return (
                                    <>
                                      {index !== 0 && <div className="page-arrow" style={{ marginTop: "75%" }} />}
                                      {goalCards(goal.custom_title, goal.uniques,goal.visits,goal.visiopt_conversions, goal.ucr, goal.gcr, goal.thumb, goal.unique_percentage)}
                                    </>
                                  );
                                })}
                              </tr>
                            </tbody>
                          </table>
                        </SimpleBar>
                        <SimpleBar forceVisible="x" autoHide={false} style={{paddingBottom : '10px'}}>
                          <Table striped highlightOnHover withBorder my={5} fontSize="xs" withColumnBorders style={{ minWidth: '2000px', tableLayout: 'auto' }}>
                            <thead>
                              <tr>
                                {trafficSourceTableColumns.map((columnName, index) => {
                                  let minWidth = 'auto';
                                  if (columnName === 'Campaign Name') minWidth = '250px';
                                  else if (columnName === 'Adset Name') minWidth = '250px';
                                  else if (columnName === 'Ad Name') minWidth = '250px';
                                  else if (columnName === 'Traffic Source') minWidth = '100px';

                                  return (
                                    <th key={index} style={{ whiteSpace: 'nowrap', textAlign: 'left', padding: '8px', minWidth }}>
                                      {columnName}
                                    </th>
                                  );
                                })}
                              </tr>
                            </thead>
                            <tbody>
                              {trafficSourceTableData.map((rowData, rowIndex) => (
                                <tr key={rowIndex}>
                                  {rowData.map((value, colIndex) => {
                                    const columnName = trafficSourceTableColumns[colIndex];
                                    let minWidth = 'auto';
                                    if (columnName === 'Campaign Name') minWidth = '250px';
                                    else if (columnName === 'Adset Name') minWidth = '250px';
                                    else if (columnName === 'Ad Name') minWidth = '250px';
                                    else if (columnName === 'Traffic Source') minWidth = '100px';
                                    return(
                                      <td key={colIndex} style={{ whiteSpace: 'nowrap', padding: '8px', minWidth}}>{value}</td>
                                    );
                                  })}
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </SimpleBar>
                      </Accordion.Panel>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </>
            )}
          </Card>
        </Card>
      </Container>
    </>
  );
}
